const ShimmerBlogLoader = () => {
    return (
        <div style={{"textAlign":"center", "padding-top":"20vh", "padding-bottom":"20vh"}}>
            <h2>Loading...</h2>
        </div>
    )
}

export default ShimmerBlogLoader;